import React from 'react';

const Loading = () => (
  <div
    style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100vw',
      height: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: '#000', 
      zIndex: 9999, 
    }}
  >
    <video
      src="/images/elebhai.mp4"
      autoPlay
      loop
      muted
      style={{
        width: '100%',
        height: '100%',
        objectFit: 'cover', 
      }}
    />
  </div>
);

export default Loading;
